<vb-loading-spinner *ngIf="!initialized; else backstageView" [size]="'large'" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'Event_Producer_SettingTheStage' | translate" [msgDisplayBelowSpinner]="true">
</vb-loading-spinner>

<ng-template #backstageView>
	<div [ngClass]="styles.topRow">
		<preview-view [ngClass]="userIsLive && !webcast.currentUser.isAssignedEventAdmin ? styles.hidePreview : ''" [isProducer]="webcast.currentUser.isAssignedEventAdmin" [producerOptions]="webcast.producerOptions" [bgImages]="webcast.producerBgImages"></preview-view>
		<onstage-view [webcast]="webcast" [producerOptions]="webcast.producerOptions" [bgImages]="webcast.producerBgImages" [isProducer]="webcast.currentUser.isAssignedEventAdmin" [broadcasting]="webcast.broadcast.isActive"></onstage-view>
	</div>
	<producer-video-controls *ngIf="backstageCollapsed" [ngClass]="styles.producerControls" [controlsOnly]="true" [controlsRow]="true">
	</producer-video-controls>

	<ng-container *ngIf="webcast.currentUser.isAssignedEventAdmin">
		<div [ngClass]="styles.bottomRow">
			<div [ngClass]="styles.collapseHeader">
				<span (click)="sceneCollapsed = !sceneCollapsed" [ngClass]="styles.collapseToggle">
					<button type="button" [ngClass]="styles.toolbarBtn" [attr.aria-label]="(sceneCollapsed ? 'UI_CollapsableSection_Expand' : 'UI_CollapsableSection_Collapse' ) | translate" [attr.aria-expanded]="!sceneCollapsed">
						<span class="glyphicons" [ngClass]="sceneCollapsed ? 'chevron-right' : 'chevron-down'"></span>
					</button>
					{{ 'Event_Producer_Scenes' | translate }}
				</span>
			</div>
			<div [collapse]="sceneCollapsed" [isAnimated]="true">
				<scene-selector #sceneSelector [largeScenes]="backstageCollapsed" [producerOptions]="producerOptions" [scenes]="producerOptions.scenes"></scene-selector>
			</div>
		</div>
	</ng-container>

	<div [ngClass]="styles.bottomRow">
		<div [ngClass]="[styles.collapseHeader, backstageCollapsed ? styles.collapsed : '']">
			<span (click)="toggleBackstagePanel()" [ngClass]="styles.collapseToggle">
				<button type="button" [ngClass]="styles.toolbarBtn" [attr.aria-label]="(backstageCollapsed ? 'UI_CollapsableSection_Expand' : 'UI_CollapsableSection_Collapse' ) | translate" [attr.aria-expanded]="!backstageCollapsed">
					<span class="glyphicons" [ngClass]="backstageCollapsed ? 'chevron-right' : 'chevron-down'"></span>
				</button>
				{{ 'Event_Producer_Backstage' | translate }}
			</span>
			<span flex="fill" [ngClass]="styles.numberMissing">
				<span class="margin-left-10" [tooltip]="ttTemplate" [isDisabled]="!missingPresenters.length" [adaptivePosition]="true" [placement]="'right'">
					{{ (numMissingPresenters > 0 ? 'Event_Producer_PeopleHereAndMissing' : 'Event_Producer_PeopleHere' ) | translate : { '0': numActivePresenters | number, '1': numMissingPresenters | number } }}
				</span>
				<ng-template #ttTemplate>
					<div class="text-align-left">{{ 'Missing' | translate }}</div>
					<div *ngFor="let user of missingPresenters" class="text-align-left" [ngClass]="styles.missingUser">
						<vb-profile-picture [altTxt]="user.name" [profileUrl]="user.profileImageUri" [placeholderInitialsFullName]="user.name" size="medium">
						</vb-profile-picture>
						{{ user.name }}
					</div>
				</ng-template>
			</span>
			<span class="margin-right-10" *ngIf="backstageVolume === 0 || userIsLive">
				{{ 'Event_Producer_BackstageMuted' | translate }}
			</span>
			<span class="margin-right-10" *ngIf="onstageVolume === 0">
				{{ 'Event_Producer_OnstageMuted' | translate }}
			</span>
			<div dropdown vbDropdown #backstageControlsDropdown="bs-dropdown" [insideClick]="true" [dropup]="backstageCollapsed" [ngClass]="styles.options">
				<button type="button" dropdownToggle class="dropdown-toggle" [ngClass]="styles.toolbarBtn">
					<span class="vb-icon vb-icon-volume-full"></span>
				</button>
				<div *dropdownMenu class="dropdown-menu dropdown-menu-right">
					<div [ngClass]="styles.volumeControl" class="list-group-item">
						<div>
							{{ (onstageVolume === 0 ? 'Event_Producer_OnstageAudio_Muted' : 'Event_Producer_OnstageAudio') | translate }}
						</div>
						<div>
							<button type="button" class="dropdown-item" (click)="toggleOnstageMute()">
								<span class="vb-icon" [ngClass]="onstageVolume === 0 ? 'vb-icon-volume-mute' : onstageVolume <= 50 ? 'vb-icon-volume-half' : 'vb-icon-volume-full'"></span>
							</button>
							<input type="range" class="dropdown-item" min="0" max="100" [(ngModel)]="onstageVolume">
						</div>
					</div>
					<div *ngIf="!userIsLive" [ngClass]="styles.volumeControl" class="list-group-item">
						<div>
							{{ (userIsLive ? 'Event_Producer_MuteBackstageDisabled' : backstageVolume === 0 ? 'Event_Producer_BackstageAudio_Muted' : 'Event_Producer_BackstageAudio') | translate }}
						</div>
						<div>
							<button type="button" class="dropdown-item" (click)="toggleBackstageMute()">
								<span class="vb-icon" [ngClass]="backstageVolume === 0 ? 'vb-icon-volume-mute' : backstageVolume <= 50 ? 'vb-icon-volume-half' : 'vb-icon-volume-full'"></span>
							</button>
							<input type="range" class="dropdown-item" min="0" max="100" [(ngModel)]="backstageVolume">
						</div>
					</div>

					<div *ngIf="userHasMic && !userIsLive && webcast.currentUser.isAssignedEventAdmin && hasLivePresenters" [ngClass]="styles.pushToTalkContainer" class="list-group-item">
						<button type="button" class="dropdown-item" vbPushHold [ngClass]="stopPushToTalk ? styles.activePushTalk : ''" (onStart)="tryStartTalkStage()" (onStop)="tryStopTalkStage()">
							{{ (stopPushToTalk
								? 'Event_Producer_PushToTalk_Speaking'
								: 'Event_Producer_PushToTalk_Stage' )| translate }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<div [collapse]="backstageCollapsed" [isAnimated]="true">
			<div [ngClass]="styles.collapseContent">
				<producer-video-controls [canEditLayout]="webcast.currentUser.isAssignedEventAdmin" [isExternal]="webcast.currentUser.isExternalPresenter" [layoutData]="webcast.producerOptions.backstageLayout" [showLabel]="true"></producer-video-controls>
				<presenter-video-list #presenterVideoList [ngClass]="webcast.layout.isRightSidebarOpen ? 'small-width' : ''" [webcast]="webcast" [canEditLayout]="webcast.currentUser.isAssignedEventAdmin" [backstageVolume]="userIsLive ? 0 : backstageVolume" [onstageVolume]="onstageVolume" [presenters]="ListenerConnection.presenters?.presenters || []" [producerIds]="webcast.eventAdminIds" [producerOptions]="webcast.producerOptions">
				</presenter-video-list>
			</div>
		</div>
	</div>

</ng-template>
